var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceParking = function SvgDeviceParking(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg10",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8m0-14c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M11.425 19.967c-1.933-.177-3.591-.916-4.927-2.194-2.26-2.164-3.049-5.346-2.06-8.317.976-2.937 3.612-5.053 6.717-5.395a10 10 0 0 1 1.7.002 7.99 7.99 0 0 1 5.177 2.713 7.97 7.97 0 0 1-.503 10.97 7.4 7.4 0 0 1-2.023 1.417 7.9 7.9 0 0 1-2.355.737c-.373.056-1.412.096-1.726.067z",
    opacity: 0.99
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "#fff",
    d: "M8.867 7.644v8.712h1.584v-3.168h3.169a2.38 2.38 0 0 0 2.376-2.376v-.792a2.38 2.38 0 0 0-2.376-2.376H9.66zm1.584 1.584h3.169c.436 0 .792.355.792.792v.792a.793.793 0 0 1-.792.792H10.45z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceParking);
export default ForwardRef;